import * as React from "react";
import { AlertMessage, AlertType, SpinnerWrapper } from "soprasteria-ui-library";
import { useAuth } from "../../../App";
import { MunicipalityDistrictApi } from "../../../api/MunicipalityDistrictApi";
import { UserContext, isInRole } from "../../../contexts/UserContext";
import { setMessage } from "../../../helpers/MessageHelper";
import { IDistrict, IMunicipality, IMunicipalityTab } from "../../../models/IMunicipalityDistrict";
import { UNKOWNDISTRICTCODE } from "../../../utils/DistrictConstants";
import { MENUETTPORTALKOMMUN_BOENDESAMORDNARE, MENUETTPORTALKOMMUN_KOMMUNALADMINISTRATÖR, MENUETTPORTALKOMMUN_PRIVATANSVARIG } from "../../../utils/RoleConstants";
import { MunicipalityInformation } from "./MunicipalityInformation";
import { MunicipalityTabs } from "./Tabs/MunicipalityTab";

export const Municipality: React.FC<{}> = () => {
    const userInfo = React.useContext(UserContext);
    const hasRoleBoendesamordnare = isInRole(MENUETTPORTALKOMMUN_BOENDESAMORDNARE, userInfo.roles ? userInfo.roles : []);
    const hasRoleKommunalAdministratör = isInRole(MENUETTPORTALKOMMUN_KOMMUNALADMINISTRATÖR, userInfo.roles ? userInfo.roles : []);
    const hasRolePrivatAnsvarig = isInRole(MENUETTPORTALKOMMUN_PRIVATANSVARIG, userInfo.roles ? userInfo.roles : []);
    
    const auth = useAuth();
    const api = new MunicipalityDistrictApi(auth);
    const [isLoading, setIsLoading] = React.useState<boolean>(false);
    const [errorMessage, setErrorMessage] = React.useState<string>("");
    const [successMessage, setSuccessMessage] = React.useState<string>("");
    const [municipality, setMunicipality] = React.useState<IMunicipality>();
    const [district, setDistrict] = React.useState<IDistrict>();
    const [selectedTab, setSelectedTab] = React.useState<IMunicipalityTab>();

    React.useEffect(() => {
        loadMunicipality()
    }, []);

    const loadMunicipality = () => {
        setIsLoading(true);
        api.getMunicipality((result) => {
            setMunicipality(result);
        }, (error) => { setErrorMessage(error) }, () => { setIsLoading(false); loadDistrict(); });
    }

    const loadDistrict = () => {
        setIsLoading(true);
        api.getDistrict((result) => {
            if (result.districtCode === UNKOWNDISTRICTCODE) {
                setDistrict(undefined);
            } else {
                setDistrict(result);
            }            
        }, (error) => { setErrorMessage(error) }, () => { setIsLoading(false); });
    }

    const onTabSubmit = (message: string, tab: IMunicipalityTab) => {
        setSuccessMessage(setMessage(message, successMessage));
        if (municipality) {
            setMunicipality(undefined);
            loadMunicipality();
            setSelectedTab(tab);
        }
    }

    return (
        <SpinnerWrapper isLoading={isLoading}>
            <section className="card">
                <div className="card-header">
                    <div className="row">
                        <div className="col">
                            <h1>Kommun</h1>
                        </div>
                    </div>
                </div>
                <div className="card-body">
                    <div className="col-12">
                        <AlertMessage alertType={AlertType.success} duration={5000} >{successMessage}</AlertMessage>
                        <AlertMessage alertType={AlertType.danger} duration={5000}>{errorMessage}</AlertMessage>
                    </div>
                    {
                        municipality &&
                        <>
                            <div className="relative">
                                <div className="row">
                                    <MunicipalityInformation municipality={municipality} district={district} />
                                </div>
                                <div className="row extra-top-margin">
                                    <div className="col-12">
                                        <MunicipalityTabs selectedTab={selectedTab} hasAccessToResidenceRequest={hasRoleBoendesamordnare} hasAccessToUserRoleGroups={hasRoleKommunalAdministratör || hasRolePrivatAnsvarig} onTabSubmit={onTabSubmit} />
                                    </div>
                                </div>
                            </div>
                        </>
                    }
                </div>
            </section>
        </SpinnerWrapper>
    );
}